// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:400px){.search-results .report-summary .type-icon{display:none}}.search-results .report-summary:first-of-type{margin-top:0}.search-results .report-summary:last-of-type{margin-bottom:0}.autocomplete-content{position:absolute!important;left:0;right:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
